import React from 'react';
import getApplicantInformationLabel from '@/Utils/getLabelsFunctions';
import ApplicantInformationType from '@/Models/ApplicantInformationType';
import InfoChoiceSelector from './components/InfoChoiceSelector';
import UIStrings from '@/Utils/UIStrings';
import MandatoryInformationOption from './components/MandatoryInformationOption';
import { AccordionContent, AccordionItem } from '@/Components/shadcn';
import RequestInformationAccordionTrigger from './components/RequestInformationAccordionTrigger';

const mandatoryInformationOptions: string[] = [UIStrings.CV, UIStrings.Email];

const generalInformationToggles: ApplicantInformationType[] = [
    ApplicantInformationType.PhoneNumber,
    ApplicantInformationType.NoticePeriod,
    ApplicantInformationType.ValidWorkPermit,
    ApplicantInformationType.SalaryExpectation,
];

const GeneralInformationAccordion = () => {
    return (
        <AccordionItem value={UIStrings.GeneralInformation} className="**:data-[slot=accordion-trigger]:rounded-t-2xl">
            <RequestInformationAccordionTrigger>{UIStrings.GeneralInformation}</RequestInformationAccordionTrigger>
            <AccordionContent>
                {mandatoryInformationOptions.map((value) => (
                    <MandatoryInformationOption key={value} label={value} />
                ))}
                {generalInformationToggles.map((value) => (
                    <InfoChoiceSelector
                        key={ApplicantInformationType[value]}
                        label={getApplicantInformationLabel(value)}
                        name={value}
                    />
                ))}
            </AccordionContent>
        </AccordionItem>
    );
};

export default GeneralInformationAccordion;
